import { Controller } from "@hotwired/stimulus"
import { HSOverlay } from "preline/dist/preline"

// Controller used to reliably close a Preline HSOverlay modal,
// even after Turbo frame reloads (e.g. form errors).
//
// Usage (example):
// <button
//   data-controller="preline-modal-close-button"
//   data-action="click->preline-modal-close-button#close"
//   data-hs-overlay="#hs-full-screen-modal"
//   aria-label="Close">
//   ...
// </button>
export default class extends Controller {
  close(event) {
    if (event) event.preventDefault()

    // Prefer explicit selector from data-hs-overlay (Preline convention)
    const overlaySelector = this.element.getAttribute("data-hs-overlay")

    // Try to get HSOverlay instance via selector or closest overlay element
    let overlayInstance = null

    if (overlaySelector) {
      try {
        overlayInstance = HSOverlay.getInstance(overlaySelector, true)
      } catch (e) {
        // HSOverlay might throw if selector is invalid; ignore and fallback
      }
    }

    if (!overlayInstance) {
      const overlayElement = this.element.closest(".hs-overlay")
      if (overlayElement) {
        try {
          overlayInstance = HSOverlay.getInstance(overlayElement, true)
        } catch (e) {
          // ignore, we will fallback below
        }
      }
    }

    if (overlayInstance && overlayInstance.element && typeof overlayInstance.element.close === "function") {
      overlayInstance.element.close()
      return
    }

    // Fallback: try to close/remove the overlay element directly
    if (overlaySelector) {
      const el = document.querySelector(overlaySelector)
      if (el) {
        if (typeof el.close === "function") {
          el.close()
        } else {
          el.classList.add("hidden")
        }
        return
      }
    }

    const fallbackOverlay = this.element.closest(".hs-overlay")
    if (fallbackOverlay) {
      if (typeof fallbackOverlay.close === "function") {
        fallbackOverlay.close()
      } else {
        fallbackOverlay.classList.add("hidden")
      }
    }
  }
}

